import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { getRouteApi } from '@mint/routing';

import { Box, Button, Card, Typography } from '@myn/mui';

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan/',
);

const EmptyBuilder = () => {
  const { t } = useTranslation('@myn/planning');
  const { campaignId } = routeApi.useParams();
  const navigate = routeApi.useNavigate();
  const handleRedirectToStrategy = () => {
    navigate({
      to: '/campaign/$campaignId/strategy/mediamix/$mediaMixName',
      params: { campaignId, mediaMixName: 'undefined' },
    });
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}
    >
      <Typography variant="h2">{t('Buying Plan')}</Typography>
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Illustration
            className="size-40"
            component="IllustrationEmptyState"
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              textAlign: 'center',
            }}
          >
            <Typography variant="h4">
              {t('Buying plan is not created yet')}
            </Typography>
            <Typography variant="bodyShort01">
              {t('Go to Strategy Brief to create a new Buying Plan')}
            </Typography>
          </Box>
          <Button
            color="primary"
            variant="outlined"
            size="large"
            endIcon="ArrowRight"
            onClick={handleRedirectToStrategy}
          >
            {t('Go to Strategic Brief')}
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default EmptyBuilder;
